import { combineReducers } from 'redux';
import loadingReducer from '../LoadingRedux';
import DomainReducer from '../DomainRedux';
import partnerSmsConfigReducer from '../PartnerSmsConfigRedux';

const rootReducer = combineReducers({
loading: loadingReducer,
DomainReducer: DomainReducer,
    partnerSmsConfig: partnerSmsConfigReducer
});

export default rootReducer;